import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_USER_DATA_REQUEST,
  fetchUserDataSuccess,
  fetchUserDataFailure,
  CREATE_USER_REQUEST,
  createUserSuccess,
  createUserFailure,
  CHANGE_USER_PASSWORD_REQUEST,
  changeUserPasswordSuccess,
  changeUserPasswordFailure,
  CHANGE_USER_STATUS_REQUEST,
  changeUserStatusSuccess,
  changeUserStatusFailure,
  FETCH_TEAMS_REQUEST,
  fetchTeamsSuccess,
  fetchTeamsFailure,
  UPDATE_USER_REQUEST,
  updateUserFailure,
  updateUserSuccess,
} from '../actions/userActions';
import { getBaseUrl } from '../utils/getBaseUrl';

// Helper function to get the auth token from localStorage
const getAuthToken = () => localStorage.getItem('authToken');

// Worker Saga: Fetch User Data with pagination and search
function* fetchUserData(action) {
  try {
    const token = getAuthToken();
    const { page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    console.log("Action : ",action.payload)
    const response = yield call(axios.get, `${getBaseUrl()}/teams/get-teams`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search, group },
    });
    yield put(fetchUserDataSuccess(response.data)); // Expecting `data` and `meta` in response
  } catch (error) {
    yield put(fetchUserDataFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Create User
function* createUser(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.post, `${getBaseUrl()}/teams/create-user`, action.payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(createUserSuccess(response.data));
  } catch (error) {
    console.log(error.response?.data?.message || error.message);
    yield put(createUserFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Update User
function* updateUser(action) {
  try {
    const token = getAuthToken();
    const userId = action.payload.id;
    delete action.payload.id; // Remove `id` before sending payload to the API
    const response = yield call(
      axios.put,
      `${getBaseUrl()}/teams/update-user/${userId}`,
      action.payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    yield put(updateUserSuccess(response.data));
  } catch (error) {
    yield put(updateUserFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Change User Password
function* changeUserPassword(action) {
  try {
    const token = getAuthToken();
    const response = yield call(
      axios.put,
      `${getBaseUrl()}/auth/change-password-admin`,
      action.payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    yield put(changeUserPasswordSuccess(response.data));
  } catch (error) {
    yield put(changeUserPasswordFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Change User Status
function* changeUserStatus(action) {
  try {
    const token = getAuthToken();
    const response = yield call(
      axios.post,
      `${getBaseUrl()}/teams/change-status`,
      { email: action.payload },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    yield put(changeUserStatusSuccess(response.data));
  } catch (error) {
    yield put(changeUserStatusFailure(error.response?.data?.message || error.message));
  }
}

// Worker Saga: Fetch Teams
function* fetchTeams(action) {
  try {
    const token = getAuthToken();
    const { projectId } = action.payload || {};
    const response = yield call(axios.get, `${getBaseUrl()}/teams/get-teams/project`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { projectId },
    });
    yield put(fetchTeamsSuccess(response.data));
  } catch (error) {
    yield put(fetchTeamsFailure(error.response?.data?.message || error.message));
  }
}

// Watcher Saga: Watch for actions
function* userSaga() {
  yield takeLatest(FETCH_USER_DATA_REQUEST, fetchUserData);
  yield takeLatest(CREATE_USER_REQUEST, createUser);
  yield takeLatest(CHANGE_USER_PASSWORD_REQUEST, changeUserPassword);
  yield takeLatest(CHANGE_USER_STATUS_REQUEST, changeUserStatus);
  yield takeLatest(FETCH_TEAMS_REQUEST, fetchTeams);
  yield takeLatest(UPDATE_USER_REQUEST, updateUser);
}

export default userSaga;
